/* eslint prefer-destructuring: 0 */
import { SagaIterator } from "redux-saga";
import { call, takeEvery } from "redux-saga/effects";

import { externalCallGet } from "../../http_client";

import { placesFetchRequest } from "./actions";
import { PlacesActionTypes } from "./types";

export function* handlePlacesFetch(action: ReturnType<typeof placesFetchRequest>): SagaIterator {
  const { onSearchResult, search, locale, resultSize } = action.payload;
  try {
    const res = yield call(externalCallGet, "/places/", { locale, max: resultSize ?? 7, term: search });
    if (onSearchResult !== undefined) {
      yield call(onSearchResult, res.data);
    }
  } catch (err) {
    if (onSearchResult !== undefined) {
      yield call(onSearchResult, []);
    }
  }
}

function* watchPlaceSelectorSagas(): SagaIterator {
  yield takeEvery(PlacesActionTypes.PLACES_FETCH_REQUEST, handlePlacesFetch);
}

export default watchPlaceSelectorSagas;
